export default __webpack_public_path__ + "static/media/Nirvana.5e809962.PNG";